import React from 'react';
import { LanguageProvider } from './lib/LanguageContext';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Failures } from './components/Failures';
import { Solution } from './components/Solution';
import { Testimonials } from './components/Testimonials';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <LanguageProvider data-id="element-0">
      <MetaPixel data-id="element-1" />
      <div className="min-h-screen bg-cream selection:bg-coral selection:text-white" data-id="element-2">
        <Nav data-id="element-3" />
        <main data-id="element-4">
          <Hero data-id="element-5" />
          <Problem data-id="element-6" />
          <Failures data-id="element-7" />
          <Solution data-id="element-8" />
          <Testimonials data-id="element-9" />
          <Pricing data-id="element-10" />
          <FAQ data-id="element-11" />
        </main>
        <Footer data-id="element-12" />
      </div>
    </LanguageProvider>;
}